import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BranchCardComponent } from '../branch-card/branch-card.component';
import { BenefitsService } from '../../../services/benefits.service';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { LoaderService } from '../../../../../shared/services/loader.service';


@Component({
  selector: 'app-branchs',
  imports: [CommonModule, FormsModule, BranchCardComponent],
  templateUrl: './branchs.component.html',
  styleUrl: './branchs.component.scss'
})
export class BranchsComponent implements OnInit, OnDestroy {
  sucursales: any[] = [];
  sucursalesFiltradas: any[] = [];
  searchTerm: string = '';
  private destroy$ = new Subject<void>();
  window = window;

  constructor(
    private benefitsService: BenefitsService,
    private route: ActivatedRoute,
    private loader: LoaderService
  ) {}

  ngOnInit(): void {
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        const idMarca = params['idMarca'];
        if (idMarca) {
          this.loadSucursales(Number(idMarca));
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadSucursales(idMarca: number): void {
    this.loader.show();
    this.benefitsService.getSucursales(idMarca)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.sucursales = response.data.Marcas[0]?.Sucursales || [];
          this.sucursalesFiltradas = [...this.sucursales];
          this.loader.hide();
        },
        error: (error) => {
          console.error('Error fetching sucursales:', error);
          this.sucursales = [];
          this.sucursalesFiltradas = [];
          this.loader.hide();
        }
      });
  }

  onSearchChange(): void {
    const term = this.searchTerm.trim().toLowerCase();
    
    if (!term) {
      this.sucursalesFiltradas = [...this.sucursales];
      return;
    }

    this.sucursalesFiltradas = this.sucursales.filter(sucursal =>
      sucursal.nombre?.toLowerCase().includes(term) ||
      sucursal.calle?.toLowerCase().includes(term) ||
      sucursal.zona?.toLowerCase().includes(term)
    );
  }
}
